import { render, staticRenderFns } from "./PromotionsList.vue?vue&type=template&id=3d7c7dde&scoped=true&"
import script from "./PromotionsList.vue?vue&type=script&lang=js&"
export * from "./PromotionsList.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsList.vue?vue&type=style&index=0&id=3d7c7dde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7c7dde",
  null
  
)

export default component.exports